import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { get } from 'lodash';

import pluralize from 'rebook/apps/utils/text/pluralize';
import uaDetector from 'rebook/apps/utils/uaDetector';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookListItemEmpty from 'rebook/apps/books/components/BookListItemEmpty';
import BookCardHeader from 'rebook/apps/base/components/BookCardHeader';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import BookHasNotReviews from 'rebook/apps/books/components/BookHasNotReviews';
import * as BookReviewListActions from 'rebook/apps/books/actions/BookReviewListActions';
import { Book } from 'rebook/apps/books/models';
import BookReview from 'rebook/apps/books/components/BookReview';

import styles from './style.scss';


class BookReviewListView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.BookReviewListActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.BookReviewListActions.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(BookReviewListActions.fetchInitialData(match));
  }

  changePage(newPageNumber) {
    window.scrollTo(0, 0);
    this.props.BookReviewListActions.fetchReviewList(newPageNumber);
  }

  render() {
    const { user } = this.props;
    const { reviews, book, pageNumber, lastPageNumber } = this.props.bookReviewList;
    const theBook = new Book(book);
    const isAudiobook = get(book, 'type', '') === 'audio';
    const bookTypeText = isAudiobook ? 'аудиокнигу' : 'книгу';
    const reviewsCount = get(book, 'reviews_count', 0);
    const UA = navigator && navigator.userAgent ? navigator.userAgent : null;

    if (!UA) {
      return null;
    }

    const isMobile = uaDetector.isMobile(UA);
    const mobileSeoText = `${pluralize(reviewsCount, 'отзыв', 'отзыва', 'отзывов')}`;
    const desktopSeoText = ` и ${pluralize(reviewsCount, 'рецензия', 'рецензии', 'рецензий')} на книгу`;
    const seoText = isMobile ? mobileSeoText : mobileSeoText + desktopSeoText;

    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className={styles.container}>
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/' },
            { text: get(book, 'main_author.cover_name', ''), url: get(book, 'main_author.absolute_url') },
            { text: get(book, 'name', ''), url: get(book, 'absolute_url', '') },
            { text: `Отзывы на ${bookTypeText}`, url: '' },
          ]} />
          {book && (
            <React.Fragment>
              <h1>
                Отзывы на {bookTypeText}&nbsp;
                <Link to={theBook.getLink()} className="link">
                  &laquo;{book.name}&raquo;
                </Link>
              </h1>
              <div className={styles.count}>
                {reviewsCount}&nbsp;{seoText}
              </div>
              {reviewsCount > 0
                ?
                <BookCardHeader withAuthor book={book} user={user} withButton GACategory="BookReview" />
                : (
                  <BookHasNotReviews>
                    У книги &laquo;{book.name}&raquo; еще нет отзывов
                  </BookHasNotReviews>
                )
              }
            </React.Fragment>
          )}
          {reviews === null
            ? [...Array(5)].map((count, key) => (
              <BookListItemEmpty key={key} />
            ))
            : reviews.map((review) => (
              <div className={styles.content} key={review.id}>
                <BookReview review={review} />
              </div>
            ))
          }
          {lastPageNumber > 1 && (
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookReviewList: state.bookReviewList,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookReviewListActions: bindActionCreators(BookReviewListActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookReviewListView);
